import { Box, Button, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import dayjs from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Label } from "flowbite-react";
import greenTick from '../../assets/icons/greenTic.svg';

const Delivered = () => {

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [open, setOpen] = useState(false);

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [tokenExpired, setTokenExpired] = useState(false);
    // const [editable, setEditable] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [rows, setRows] = useState([]);
    const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
    const [endDate, setEndDate] = useState(dayjs());
    const [bookingId, setBookingId] = useState('');
    const [cancelledData, setCancelledData] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('booking_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const fetchDispatchData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_bookings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp,
                start_date: startDate.format('YYYY-MM-DD'),
                end_date: endDate.format('YYYY-MM-DD'),
                status: 4 //delivered
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
                // const formattedData = formatDataForCSV(response.data);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(()=> {
        fetchDispatchData();
    },[cityFilter, startDate, endDate])

    const handleViewDetails = (row) =>{
        setBookingId(row.booking_id);
        setOpen(true);
    }
    useEffect(()=>{
        fetchCancelledDetails();
    }, [bookingId, open])
    // useEffect(() => {
    //     if(bookingId!='')
    //     setOpen(true);
    // }, [cancelledData, bookingId])

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const fetchCancelledDetails = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_booking_engagements';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                // city_id: cityFilter,
                timestamp: timestamp,
                booking_id: bookingId
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                console.log('response', response.data[0]);
                setCancelledData(response.data);
                // const formattedData = formatDataForCSV(response.data);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const handleClose = () => {
        setOpen(false);
    }

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
            Delivered
            </Typography>

            <Grid2 container spacing={2} alignItems="flex-end" style={{marginBottom: '2%'}}>
                <Grid2 item>
                    <Label></Label><br/>
                    <Select 
                        value={cityFilter} 
                        onChange={(e) => handleCityChange(e.target.value)} 
                        displayEmpty
                        sx={{
                            width: '190px',
                            height: '50px',
                            borderRadius: '8px', marginTop:"8px",
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item sx={{marginLeft:'3%'}}>
                    <Label>Start Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDate && startDate && startDate > endDate
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={startDate}
                            onChange={(newValue) => {
                                if (endDate && newValue > endDate) {
                                    // If new start date is after end date, clear end date
                                    setEndDate(null);
                                }
                                setStartDate(newValue);
                            }}
                            maxDate={endDate || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item>
                    <Label>End Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDate && startDate && startDate > endDate
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            minDate={startDate || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>
            </Grid2>

            {open && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                    <Grid2 container spacing={2} alignItems="center" style={{marginBottom: '2%' }}>
                                        <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                            Delivered Booking
                                        </Typography>
                                        <Grid2 item sx={{marginLeft:'auto', border:'1px solid #0DBA78', padding:'8px', borderRadius:'8px', display:'flex', alignItems:'center'}}>
                                            <img height="15px" width="15px" src={greenTick} alt="delivered" />
                                            <Typography sx={{color:'#0DBA78', marginLeft:'4px'}}>Delivered</Typography>
                                        </Grid2>
                                    </Grid2>
                                

                                <Grid container spacing={2} style={{marginBottom:'6%'}}>
                                    
                                    <Grid item xs={12} sm={12}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Booking ID<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}} placeholder="Booking ID" fullWidth variant="outlined" type="text"
                                            value={cancelledData[0]?.booking_id} disabled
                                            // onChange={(e) => setTruckerName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF'
                                                },
                                            }}
                                        />
                                    </Grid>

                                    {/* <Grid item xs={12} sm={12}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Reason<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}} placeholder="Reason" fullWidth variant="outlined" type="text"
                                            value={cancelledData[0]?.reason} disabled
                                            // onChange={(e) => setTruckerName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid> */}

                                    <Grid item sx={12} sm={12}>
                                        <Grid2 sx={{border :'1px solid #7C7C7C', borderRadius:'12px', padding:'2%'}}>
                                            <Grid2 sx={{padding:'8px', backgroundColor:'#F4F2F2', borderRadius:'8px', marginBottom:'2%'}}>
                                                Route Details
                                            </Grid2>

                                        <Grid item xs={12} sm={12}>
                                            <Label style={{color:'#1A1E25', fontSize:'16px'}}>Pickup Address<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{marginTop:'1%'}} placeholder="Pickup Address" fullWidth variant="outlined" type="text"
                                                value={cancelledData[0]?.pickup_address} disabled
                                                // onChange={handleEmailChange}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {
                                                        height: '48px',
                                                        borderRadius:'12px',
                                                        fontSize: '16px',
                                                        padding: '8px 14px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} sx={{marginTop:'8px'}}>
                                            <Label style={{color:'#1A1E25', fontSize:'16px'}}>Drop Address<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{marginTop:'1%'}} placeholder="Drop Address" fullWidth variant="outlined" type="text"
                                                value={cancelledData[0]?.drop_address} disabled
                                                // onChange={handleEmailChange}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {
                                                        height: '48px',
                                                        borderRadius:'12px',
                                                        fontSize: '16px',
                                                        padding: '8px 14px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        </Grid2>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Client<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}} placeholder="Client" fullWidth variant="outlined" type="text"
                                            value={cancelledData[0]?.tms_client_id} disabled
                                            // onChange={handleEmailChange}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Plate Number<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}} placeholder="Plate Number" fullWidth variant="outlined" type="text"
                                            value={cancelledData[0]?.chassis_license_plate_no} disabled
                                            // onChange={handleEmailChange}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Driver<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}} placeholder="Driver" fullWidth variant="outlined" type="text"
                                            value={cancelledData[0]?.driver_id} disabled
                                            // onChange={handleEmailChange}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Helper<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}} placeholder="Helper" fullWidth variant="outlined" type="text"
                                            value={cancelledData[0]?.helper_id} disabled
                                            // onChange={handleEmailChange}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Chassis No<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}} placeholder="Chassis No" fullWidth variant="outlined" type="text"
                                            value={cancelledData[0]?.chassis_id} disabled
                                            // onChange={handleEmailChange}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                </Grid>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container" sx={{maxHeight:'70vh'}}>
                <Table stickyHeader className="scrollable-table">
                <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'booking_id'} direction={orderBy === 'booking_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('booking_id')}>
                                    Booking ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'tms_client_name'} direction={orderBy === 'tms_client_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('tms_client_name')}>
                                    Client
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'driver_name'} direction={orderBy === 'driver_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('driver_name')}>
                                    Driver
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'container_movement_type'} direction={orderBy === 'container_movement_type' ? order : 'asc'}
                                    onClick={() => handleRequestSort('container_movement_type')}>
                                    Type Of Movement
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'container_size'} direction={orderBy === 'container_size' ? order : 'asc'}
                                    onClick={() => handleRequestSort('container_size')}>
                                    Size
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'pickup_address'} direction={orderBy === 'pickup_address' ? order : 'asc'}
                                    onClick={() => handleRequestSort('pickup_address')}>
                                    Source
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'drop_address'} direction={orderBy === 'drop_address' ? order : 'asc'}
                                    onClick={() => handleRequestSort('drop_address')}>
                                    Destination
                                </TableSortLabel>
                            </TableCell>
                            {/* <TableCell>Request Delivery</TableCell> */}
                            {/* <TableCell>Plate No</TableCell> */}
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'pickup_time'} direction={orderBy === 'pickup_time' ? order : 'asc'}
                                    onClick={() => handleRequestSort('pickup_time')}>
                                    Trip Start Date
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'drop_time'} direction={orderBy === 'drop_time' ? order : 'asc'}
                                    onClick={() => handleRequestSort('drop_time')}>
                                    Trip End Date
                                </TableSortLabel>
                            </TableCell>
                            {/* <TableCell>First Container</TableCell> */}
                            <TableCell align="center" className="table-header">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return(
                                <TableRow key={row.booking_id}>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.booking_id}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.tms_client_name}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.driver_name}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.container_movement_type}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.container_size}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pickup_address}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.drop_address}</Typography></TableCell>
                                    {/* <TableCell>{row.address}</TableCell> */}
                                    {/* <TableCell>{row.address}</TableCell> */}
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '140px' }}>
                                        {row.pickup_time ? dayjs(row.pickup_time).format('YYYY-MM-DD HH:mm:ss') : ''}
                                    </Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '140px' }}>
                                        {row.drop_time ? dayjs(row.drop_time).format('YYYY-MM-DD HH:mm:ss') : ''}
                                    </Typography></TableCell>
                                    {/* <TableCell>{row.address}</TableCell> */}
                                    <TableCell align="center">
                                        <Button sx={{textTransform: 'none', borderRadius:'8px', width:'140px'}}
                                            variant="contained"
                                            color="primary"
                                            onClick={() => handleViewDetails(row)}
                                        >
                                            View Details
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            
        </div>
    )
}

export default Delivered;